import {Pipe, PipeTransform} from '@angular/core';
import {isToday} from 'date-fns';

@Pipe({
  name: 'isToday'
})
export class IsTodayPipe implements PipeTransform {

  transform(value: Date | string): boolean {
    if (typeof value === 'string') {
      return isToday(new Date(value));
    }
    return isToday(value);
  }

}
